import StkDepoTanimDTO from 'src/models/StokEczane/DepoTanimlari/StkDepoTanimDTO';
import api from '../core/api';
import WareHourseQueryRequest from 'src/models/StokEczane/DepoTanimlari/WareHouseQueryRequest';
import { ApiResponse } from '../core';
import VwStkDepotanimsorguDTO from 'src/models/StokEczane/DepoTanimlari/VwStkDepotanimsorguDTO ';
import VwServisdepolistDTO from 'src/models/StokEczane/DepoTanimlari/VwServisdepolistDTO';
import VwKullaniciDepotanimlariDTO from 'src/models/StokEczane/DepoTanimlari/VwKullaniciDepotanimlariDTO';

const controllerName = 'DepoTanim';
export const depoTanimApi = api.injectEndpoints({
  endpoints: (builder) => ({
    GetDepoTanimList: builder.query<
      ApiResponse<Array<VwStkDepotanimsorguDTO>>,
      WareHourseQueryRequest
    >({
      query: (request) => ({
        url: controllerName + '/GetWareHouseDescList',
        method: 'POST',
        body: JSON.stringify(request)
      })
    }),
    GetDepoTanimById: builder.query<
      StkDepoTanimDTO,
      { id: number }
    >({
      query: (req) => ({
        url: controllerName + '/GetById',
        method: 'GET',
        params: {
          id: req.id
        }
      })
    }),
    GetServisDepoList: builder.query<Array<VwServisdepolistDTO>, { id: number }>({
      query: (req) => ({
        url: controllerName + '/GetServisDepoList',
        method: 'GET',
        params: {
          id: req.id
        }
      })
    }),
    AddDepoTanim:builder.mutation<StkDepoTanimDTO,StkDepoTanimDTO>({
      query:(req)=>({
        url:controllerName+'/Add',
        method:'POST',
        body:JSON.stringify(req)
      })
    }),
    UpdateDepoTanim:builder.mutation<StkDepoTanimDTO,StkDepoTanimDTO>({
      query:(req)=>({
        url:controllerName+'/Update',
        method:'PUT',
        body:JSON.stringify(req)
      })
    }),
    AddDepoServis:builder.mutation<VwServisdepolistDTO, VwServisdepolistDTO>({
      query:(req) => ({
        url: controllerName + '/AddDepoServis',
        method: "POST",
        body: JSON.stringify(req)
      })
    }),
    DeleteServisDepo:builder.mutation<VwServisdepolistDTO, {id: number}>({
      query:(req) => ({
        url: controllerName + '/DeleteServisDepo',
        method: "DELETE",
        params: {
          id: req.id
        }
      })
    }),
    GetKullaniciDepoTanimList: builder.query<
      ApiResponse<Array<VwKullaniciDepotanimlariDTO>>,
      void
    >({
      query: (req) => ({
        url: controllerName + '/GetKullaniciDepoTanimList',
        method: 'GET',
      }),
      providesTags:["KullaniciDepo"]
    }),
  })
});

export const {
  useGetDepoTanimListQuery,
  useLazyGetDepoTanimListQuery,
  useGetDepoTanimByIdQuery,
  useLazyGetDepoTanimByIdQuery,
  useAddDepoTanimMutation,
  useUpdateDepoTanimMutation,
  useGetServisDepoListQuery,
  useLazyGetServisDepoListQuery,
  useAddDepoServisMutation,
  useDeleteServisDepoMutation,
  useLazyGetKullaniciDepoTanimListQuery
} = depoTanimApi;
